import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BodychangeService {

  constructor() { 
    this.BodyChange(null,null,null,null,null);
  }

  df; dl; dg; dDecw; dtherm;

  BodyChange = (df = 0, dl = 0, dg = 0, dDecw = 0, dtherm = 0) => {
      this.df = df;
      this.dl = dl;
      this.dg = dg;
      this.dDecw = dDecw;
      this.dtherm = dtherm;
  };

  spawnFromBodyChange = (df, dl, dg, dDecw, dtherm):BodychangeService => {
    let bc = new BodychangeService();
    bc.BodyChange(df, dl, dg, dDecw, dtherm);
    return bc;
  }
}
